import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { CallToActionStyle } from '../../../styles/components/common/blocks';
import { Button } from '../ui';

export interface ICallToActionProps {
  title: string;
  subtitle?: string;
  buttons: {
    label: string;
    path?: string;
    pathTargetBlank?: boolean;
    action?: () => void;
  }[];
  isSecondary?: boolean;
  isSubtle?: boolean;
}

const CallToAction = (props: ICallToActionProps) => {
  const router = useRouter();
  const buttonsColor = (index?: number) => {
    if (props.isSubtle && index !== undefined) {
      return index === 0 ? 'cta-primary' : 'cta-outline';
    } else {
      return 'cta-primary';
    }
  };

  return (
    <div
      className={
        CallToActionStyle['call-to-action'] +
        (props.isSecondary
          ? ` ${CallToActionStyle['call-to-action-secondary']}`
          : '') +
        (props.isSubtle ? ` ${CallToActionStyle['call-to-action-subtle']}` : '')
      }>
      <div className={`${CallToActionStyle['call-to-action-heading']}`}>
        <ReactMarkdown>{props.title}</ReactMarkdown>
        {props.subtitle && <p>{props.subtitle}</p>}
      </div>

      {!props.isSecondary && props.buttons && props.buttons.length > 0 && (
        <div className={CallToActionStyle['call-to-action-buttons']}>
          {props.buttons.map((button, index) => (
            <Button
              key={index}
              color={buttonsColor(index)}
              onClick={() => {
                if (button.action) {
                  button.action();
                } else if (button.path) {
                  if (button.pathTargetBlank) {
                    window.open(
                      `${window.location.origin}${button.path}`,
                      '_blank'
                    );
                  } else {
                    router.push(`${button.path}`);
                  }
                }
              }}>
              {button.label}
            </Button>
          ))}
        </div>
      )}

      {props.isSecondary && props.buttons && props.buttons.length > 0 && (
        <div className={CallToActionStyle['call-to-action-buttons']}>
          {props.buttons.map((button, index) => (
            <Button
              key={index}
              color={index % 2 === 0 ? 'cta' : 'cta-outline'}
              onClick={() => {
                if (button.action) {
                  button.action();
                } else if (button.path) {
                  if (button.pathTargetBlank) {
                    window.open(
                      `${window.location.origin}${button.path}`,
                      '_blank'
                    );
                  } else {
                    router.push(`${button.path}`);
                  }
                }
              }}>
              {button.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CallToAction;
